import * as React from "react";
import { Box, Typography } from "@mui/material";
import { marketingFonts } from "../../app/components/tickitMarketingTheme";
import { layout } from "./templateLayout";

/**
 * Logo + headline + subtitle shared across registration templates.
 * variant: "light" (white text on colored bg) | "dark" (accent-colored text on white)
 */
export default function RegistrationBrandingHeader({
  branding = {},
  event,
  variant = "light",
  centered = true,
  accentColor,
}) {
  const isLight = variant === "light";
  const textColor = isLight ? "#fff" : accentColor;

  return (
    <Box sx={{ textAlign: centered ? "center" : "left", color: textColor }}>
      {branding.logoUrl && (
        <Box
          component="img"
          src={branding.logoUrl}
          alt="Logo"
          sx={{
            ...layout.logo,
            mx: centered ? "auto" : 0,
            display: "block",
          }}
        />
      )}
      <Typography
        component="h1"
        sx={{
          fontFamily: marketingFonts.display,
          ...layout.headline,
          color: "inherit",
        }}
      >
        {branding.headline || event?.title}
      </Typography>
      {branding.subtitle && (
        <Typography
          sx={{
            fontFamily: marketingFonts.body,
            ...layout.subtitle,
            color: "inherit",
            opacity: isLight ? 0.95 : 0.85,
          }}
        >
          {branding.subtitle}
        </Typography>
      )}
    </Box>
  );
}
